<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div class="border border-gray-100 rounded-xl p-5 shadow-sm relative overflow-hidden">
        <b-skeleton animation="wave" width="40%" height="16px" class="mb-1"></b-skeleton>
        <div class="flex items-center gap-2 mt-2">
          <b-skeleton animation="wave" width="80px" height="48px"></b-skeleton>
          <b-skeleton animation="wave" width="20px" height="20px"></b-skeleton>
        </div>
      </div>
    </template>
    <div class="border border-gray-100 rounded-xl p-5 shadow-sm relative overflow-hidden">
      <div div class="flex justify-between items-start mb-1">
        <span class="text-gray-700 font-medium">Exactitud</span>

        <span
          class="flex items-center text-xs font-bold text-emerald-600 bg-emerald-50 border border-emerald-100 px-2 rounded-lg">
          {{trenIcon}}{{ accuracyData.trendValue }}%
          <trend :trend="accuracyData.trend" />
        </span>
      </div>

      <div class="text-5xl font-bold text-gray-900 mb-2">
        {{ Math.floor(accuracyData.accuracy) }}<span class="text-2xl text-gray-400 ml-1">%</span>
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import { getCourseAccuracy } from '@/services/CourseStats.service';
import  Trend  from '@/views/V2/statistics/components/Trend.vue';

export default {
  name: "CourseAccuracy",

  components: {
    Trend,
  },

  data() {
    return {
      loading: true,
      accuracyData: {
        accuracy: 0,
        trendValue: 0,
        trend: '', // "UP", "DOWN", "SAME"
      },
    };
  },

  props: {
    courseId: {
      type: Number,
      required: true,
      default: 0
    },
    isPremium: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    courseId(newValue) {
      // No cargar datos si no es premium
      if (!this.isPremium) {
        return;
      }
      this.loadAccuracyData(newValue)
    },
    isPremium(newValue) {
      // Si el usuario se vuelve premium, cargar los datos
      if (newValue && this.courseId) {
        this.loading = true;
        this.loadAccuracyData(this.courseId);
      }
    }
  },

  created() {
    // Si no es premium, mantener loading indefinidamente y no cargar datos
    if (!this.isPremium) {
      this.loading = true;
      return;
    }
    
    this.loadAccuracyData(this.courseId);
  },

  mounted() {
    // Si no es premium, mantener skeleton indefinidamente
    if (!this.isPremium) {
      this.loading = true;
    }
  },

  methods: {
    async loadAccuracyData(courseId) {
      if (!courseId || !this.isPremium) return;

      this.accuracyData = await getCourseAccuracy(courseId);
      this.loading = false; // Ocultar skeleton inmediatamente después de cargar
    }
  },

  computed: {
    trenIcon() {
      const icons = {
        UP: '+',
        DOWN: '-',
        SAME: '',
        NONE: '',
      }
      return icons[this.accuracyData.trend];
    }
  }
};
</script>